import React, { useEffect, useRef } from 'react';
import { useApp } from '../context/AppContext';
import LogsViewer from './shared/LogsViewer';
import './LogsPage.css';

const LogsPage: React.FC = () => {
  const { actions } = useApp();
  const hasLoadedRef = useRef(false);

  // Clear filters on mount to show all logs (unfiltered view)
  useEffect(() => {
    hasLoadedRef.current = false;
    actions.setDashboardFilters(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Run only once on mount

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <LogsViewer
            title="Gateway Logs"
            stripAllPrefixes={true}
          />
        </div>
      </div>
    </div>
  );
};

export default LogsPage;

